import React from 'react';
import {FileDrop} from 'react-file-drop';
import {Button} from 'reactstrap';

import './FileDropWrapper.css';

interface Props {
    saveFiles?: (files: FileList) => Promise<void>,
    onFileInput?: (files: FileList) => Promise<void>,
    isUploadingFiles: boolean,
    multiple?: boolean
}

class FileDropWrapper extends React.Component<Props> {
    fileInputRef: HTMLInputElement | null | undefined
    
    render() {
        const {saveFiles, onFileInput, isUploadingFiles, multiple} = this.props;
        const onFileInputChange = async (event: any) => {
            const files = event.target.files as FileList;
            await onDrop(files);
        };

        const onTargetClick = () => {
            if (this.fileInputRef)
                this.fileInputRef.click();
        };
        
        const onDrop = async (files: FileList | null) => {
            if (files) {
                if (onFileInput)
                    await onFileInput(files);
                if (saveFiles)
                    await saveFiles(files);
            }
        };
        
        const renderDropContent = () => {
            return isUploadingFiles ? <>Uploading...</> : 
                <>
                    Drag and drop file{multiple ? "s" : ""} here to upload<br/>
                    or<br/>
                    <Button outline={true} className="files-button" color="secondary" onClick={onTargetClick} size="sm" block>Choose file{multiple ? "s" : ""}</Button>
                </>;
        }

        return <>
            <FileDrop
                onDrop={onDrop}
            >
                {renderDropContent()}
            </FileDrop>
            <input
                onChange={onFileInputChange}
                ref={el => this.fileInputRef = el}
                type="file"
                multiple={multiple}
                style={{display: "none"}}
            />
        </>;
    }
}

export default FileDropWrapper;